import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ChartWrapper = styled.div`
	margin-top: 20px;
`;

export const Wrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const LoadingOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0.6;
	background-color: ${colors.white};
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TooltipWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 5px;
`;

export const TooltipHeader = styled.div`
	font-weight: bold;
	margin-bottom: 6px;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	text-align: center;
`;

export const TooltipRowTitle = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	padding-right: 16px;
`;

export const TooltipRowValue = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	justify-content: flex-end;
	text-transform: uppercase;
`;

export const ColorWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ColorSymbol = styled.div`
	min-width: 6px;
	max-width: 6px;
	min-height: 6px;
	max-height: 6px;
	background-color: ${({ color }) => color};
	border-radius: 50%;
`;

export const TooltipGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(12px, 12px) 2fr 1fr;
	padding: 1px 2px;
	width: 100%;
`;

export const TooltipRowPinned = styled(TooltipGrid)`
	padding-bottom: 8px;
`;

export const ButtonWrapper = styled.div`
	position: absolute;
	z-index: 1;
	margin-top: 25px;
	margin-left: 15px;
`;
